/* This is a global events channel! used for triggering code
 across scripts. Example:

 in foo.js: TBT.eventChannel.trigger(TBT.eventChannel.looksClosed)
 in bar.js: TBT.eventChannel.on(TBT.eventChannel.looksClosed, function() {
   thisCodeMust.runAfterlooksClosed()
 })
*/

const multiChannelSep = /(?:,|\s)+/g
const channelSep = /:+/g
let channels = {}

function _getChannels(channelString) {
  return channelString.trim().split(multiChannelSep)
}

function _getNameSpaces(channel) {
  const namespaces = []
  const splittedChannels = channel.trim().split(channelSep)

  for (let i = splittedChannels.length; i >= 1; i -= 1) {
    namespaces.push(splittedChannels.slice(0, i).join(':'))
  }

  return namespaces
}

function trigger(e, data) {
  _getChannels(e).forEach((channel) =>
    _getNameSpaces(channel).forEach((namespace) => {
      if (channels[namespace]) channels[namespace].forEach((callback) => callback.call(this, data))
    }),
  )
}

function on(e, callback) {
  _getChannels(e).forEach((channel) => {
    if (!channels[channel]) {
      channels[channel] = []
    }

    channels[channel].push(callback)
  })
}

function reset() {
  channels = {}
}

export default {
  // triggered when event data changes
  eventChanged: 'event-changed',
  on,
  pathnameChanged: 'pathname-changed',
  reset,
  trigger,
  // triggered when user data changes
  userChanged: 'user-changed',
}
